<section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 lg:py-20 bg-gray-50">
  <section class="container mx-auto flex flex-col gap-y-4">
    <div class="text-center flex flex-col items-center gap-2">
      <h3 class="font-semibold text-3xl lg:text-4xl">
        Trusted Since 2017, we pioneered this niche.
      </h3>
      <p class="lg:w-[60%] text-sm lg:text-base">
        Check out our google reviews. We don’t sell you. They say that if you
        don’t pay for what you use, then you’re the one that’s for sale. Our
        business model is selling a service, not selling you.
      </p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-5">
      <div
        *ngFor="let testimonial of testimonials"
        class="shadow rounded p-4 flex flex-col justify-between space-y-3"
      >
        <div class="flex flex-col gap-2">
          <!-- Stars -->
          <span class="flex gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="#ffd700"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="#ffd700"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="#ffd700"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="#ffd700"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="#ffd700"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
          </span>
          <!-- Text -->
          <p>
            {{ testimonial.message }}
          </p>
        </div>

        <!-- Details -->
        <div class="border-t pt-2">
          <h5 class="font-semibold text-base md:text-lg">
            {{ testimonial.name }}
          </h5>
          <p class="text-xs text-gray-400">{{ testimonial.time }}</p>
        </div>
      </div>
    </div>
  </section>
</section>
